// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skip-nav {
  position: fixed;
  opacity: 0;
  top: -40px;
  left: 10px;
  z-index: 999;
  border-radius: 5px;
  padding: 10px;
  background: #3c763d;
  color: white;
  text-decoration: underline;
  transition: top 0.3s, opacity 0.3s;
}
.skip-nav:focus {
  top: 10px;
  opacity: 1;
  transition: top 0.3s, opacity 0.3s;
}`, "",{"version":3,"sources":["webpack://./client/components/SkipToMainContent/style.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,kCAAA;AACJ;AACI;EACE,SAAA;EACA,UAAA;EACA,kCAAA;AACN","sourcesContent":[".skip-nav {\n    position: fixed;\n    opacity: 0;\n    top: -40px;\n    left: 10px;\n    z-index: 999;\n    border-radius: 5px;\n    padding: 10px;\n    background: #3c763d;\n    color: white;\n    text-decoration: underline;\n    transition: top 0.3s, opacity 0.3s;\n  \n    &:focus {\n      top: 10px;\n      opacity: 1;\n      transition: top 0.3s, opacity 0.3s;\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
